// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicWebV1GetReviewsRequest,
  TPublicWebV1GetReviewsModel,
  IMappers,
  TPublicWebV1GetReviewsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicWebV1GetReviewsResponseSchema } from '../../../entities/response/PublicWebV1GetReviewsResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicWebV1GetReviewsModel(
  parameters: TPublicWebV1GetReviewsRequest,
): TPublicWebV1GetReviewsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/web/v1/get-reviews/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicWebV1GetReviewsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicWebV1GetReviewsRequest;
}

export async function fetchPublicWebV1GetReviews<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicWebV1GetReviewsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicWebV1GetReviewsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicWebV1GetReviewsModel(parameters),
    config,
  )) as FetchResponse<TPublicWebV1GetReviewsResponse>;

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicWebV1GetReviewsResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicWebV1GetReviewsResponse>;
}
